import constants from './constants';

export default function getButtonUrl() {
  const url = new URL(constants.url);

  url.searchParams.append('phone', `${constants.dialcode} ${constants.phone}`);
  url.searchParams.append('text', constants.text);

  return url.href;
}
